import { render } from "./FormFAQ.vue?vue&type=template&id=624dc232"
import script from "./FormFAQ.vue?vue&type=script&lang=js"
export * from "./FormFAQ.vue?vue&type=script&lang=js"
script.render = render

export default script